export enum BookingStatus {
  INITIALIZED = 'initialized',
  FINALIZED = 'finalized',
  CONFIRMED = 'confirmed',
  THREE_DOMAIN_SECURE_REQUIRED = 'three_domain_secure_required'
}
